import { api } from "api";
import { useQuery } from "@tanstack/react-query";

/**
 * Client hook to obtain PMS summary information for a given patient.
 * @param pmsId The PMS ID of the patient to look up.
 * @returns React Query properties.
 */
export function usePmsSummaryQuery(pmsId: string) {
    return useQuery({
        queryKey: ["pmsSummary", pmsId],
        queryFn: async (context) => await api.provider.pmsSummary(pmsId, context.signal),
        // NOTE: This may query a few times in a row for merges, but we don't want to set a stale time and risk showing
        // out of date PMS data as a result, so we just live with it. Merges are not particularly common anyway.
    });
}
